import { render, staticRenderFns } from "./PromotionSwiperContainer.vue?vue&type=template&id=a98d9a1c&scoped=true"
import script from "./PromotionSwiperContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionSwiperContainer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionSwiperContainer.vue?vue&type=style&index=0&id=a98d9a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d9a1c",
  null
  
)

export default component.exports